import { BasicEntity } from './common.models';

/* export const enum CHECKOUT_SESSION_STATUS {
  OPEN = 'open',
  COMPLETE = 'complete',
  EXPIRED = 'expired',
} */

/* export const enum CHECKOUT_SESSION_PAYMENT_STATUS {
  PAID = 'paid',
  UNPAID = 'unpaid',
  NO_PAYMENT_REQUIRED = 'no_payment_required',
} */

// Application checkout result; succeeded includes completed no-cost orders.
export enum PAYMENT_STATUS {
  CANCELED = 'canceled',
  PROCESSING = 'processing',
  REQUIRES_ACTION = 'requires_action',
  REQUIRES_CAPTURE = 'requires_capture',
  REQUIRES_CONFIRMATION = 'requires_confirmation',
  REQUIRES_PAYMENT_METHOD = 'requires_payment_method',
  SUCCEEDED = 'succeeded'
}

export const PAYMENT_STATUS_PENDING: PAYMENT_STATUS[] = [
  PAYMENT_STATUS.PROCESSING,
  PAYMENT_STATUS.REQUIRES_ACTION,
  PAYMENT_STATUS.REQUIRES_CAPTURE,
  PAYMENT_STATUS.REQUIRES_CONFIRMATION,
];

export const PAYMENT_STATUS_RANKS: { [key in PAYMENT_STATUS]?: number } = {
  [PAYMENT_STATUS.SUCCEEDED]: 6,
  [PAYMENT_STATUS.REQUIRES_PAYMENT_METHOD]: 5,
  [PAYMENT_STATUS.PROCESSING]: 4,
  [PAYMENT_STATUS.CANCELED]: 3,
  [PAYMENT_STATUS.REQUIRES_CAPTURE]: 2,
  [PAYMENT_STATUS.REQUIRES_ACTION]: 1,
  [PAYMENT_STATUS.REQUIRES_CONFIRMATION]: 1,
};

export enum SIMPLIFIED_PAYMENT_STATUS {
  PENDING = 'pending',
  SUCCESS = 'success',
  FAILED = 'failed',
}

/* export const enum INVOICE_STATUS {
  DRAFT = 'draft',
  OPEN = 'open',
  PAID = 'paid',
  VOID = 'void',
  UNCOLLECTIBLE = 'uncollectible',
} */

export interface Payment extends BasicEntity {
  contestantId: string;
  projectId: string;
  checkoutSessionId: string;
  paymentIntentId: string | null;
  invoiceId: string | null;
  status: PAYMENT_STATUS;
  metadata: unknown; // PaymentIntent snapshot for paid orders, Checkout Session snapshot for no-cost orders.
}

export interface CheckoutPaymentResult {
  sessionId: string;
  projectId: string;
  status: PAYMENT_STATUS | null;
}
